import { render } from "./ModelPriceView.vue?vue&type=template&id=784ef51e"
import script from "./ModelPriceView.vue?vue&type=script&lang=js"
export * from "./ModelPriceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__